// extracted by mini-css-extract-plugin
export default {"root":"cards_root__wTVk2","deleteIcon":"cards_deleteIcon__53smu"};